/**
 * CMCD parameter name.
 *
 *
 * @beta
 */
export const CMCD_PARAM = 'CMCD'
